import { useIntl } from 'react-intl';

import { useBillingCycle, useUnitCount } from '../hooks.ts';

import {
	FreePriceCard,
	StandardPriceCard,
	PremiumPriceCard,
	EnterprisePriceCard,
	ProductPriceCardProps,
} from './pricing-calculator-plan-card.tsx';

const OMIT_TIER_UNIT_THRESHOLD = 26;

export const LoomFreePriceCard = (props: ProductPriceCardProps) => {
	const omitRange = useOmitRange();
	return (
		<FreePriceCard {...props} omitRange={omitRange} hasRangeSlot={omitRange ? false : undefined} />
	);
};

export const LoomBusinessPriceCard = (props: ProductPriceCardProps) => {
	const omitRange = useOmitRange();
	return <StandardPriceCard {...props} omitRange={omitRange} />;
};

export const LoomBusinessPlusAiPriceCard = (props: ProductPriceCardProps) => {
	const omitRange = useOmitRange();
	const intl = useIntl();

	const customBannerText = intl.formatMessage({
		id: 'LoomBusinessPlusAiPriceCard.mostPopular',
		defaultMessage: 'Most popular',
	});

	return <PremiumPriceCard {...props} omitRange={omitRange} customBannerText={customBannerText} />;
};

export const LoomEnterprisePriceCard = (props: ProductPriceCardProps) => {
	const omitRange = useOmitRange();
	return <EnterprisePriceCard {...props} omitRange={omitRange} priceAltElement={<div />} />;
};

const useOmitRange = () => {
	const [billingCycle] = useBillingCycle();
	const [unitCount] = useUnitCount();
	return billingCycle === 'ANNUAL' && unitCount < OMIT_TIER_UNIT_THRESHOLD;
};
